import {
  Week,
  WeekIdentifier,
  WorkCenterViewModel,
  WorkCenterWeek
} from '../Incrementals.types';
import { UiQueries } from './UiQueries';

export function getWorkCenterWeekQuery(
  this: UiQueries,
  weekId: WeekIdentifier,
  workCenter: WorkCenterViewModel
): WorkCenterWeek {
  // there should always be a match
  const week = this.getWeek(weekId);
  const notNullWeek = week as Week;

  // there should always be a match
  const workCenterWeek = notNullWeek.workCenterWeeks.filter(
    (workCenterWeekElement) => workCenterWeekElement.workCenter === workCenter
  )[0];

  return workCenterWeek;
}
